// Более высокие качества YouTube, чем есть среди MP4 со звуком в выдаче, — для эксперимента
// tzPlatformLinks (как в save-from Result.jsx). Ответ /api/convert этого проекта: ссылки — в `url[]`
// (у save-from — `urls[]`), качество — строка `quality` ("720"), `video_quality` — строки, `meta.duration` — "m:ss".
// Общий для одиночного видео (ResultDefault.vue) и карточки плейлиста (PlaylistCard.vue).
export function getBetterQualities(data) {
  if (!data || !Array.isArray(data.video_quality) || !Array.isArray(data.url)) {
    return false;
  }
  const hostingYt = data.hosting === '101';

  if (!hostingYt) return false;

  const ytQuality = data.video_quality.map((q) => parseInt(q, 10)).filter((q) => q > 0);
  const videoQualities = data.url
    .filter(i => i.name === 'MP4' && (i.no_audio === false || i.no_audio === undefined))
    .map(i => i.qualityNumber || parseInt(i.quality) || 0)
    .filter(q => q >= 480);

  const maxVideoQuality = Math.max(...videoQualities, 480);
  const ytMaxQuality = Math.max(...ytQuality, 480);

  if (ytMaxQuality === maxVideoQuality) {
    return false;
  }

  const better = ytQuality.filter((q) => q > maxVideoQuality);
  better.duration = data.meta && data.meta.duration;
  return better;
}
